/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectPriorityDropdown_project = {
    readonly id: string;
    readonly priorityLevel: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly " $refType": "ProjectPriorityDropdown_project";
};
export type ProjectPriorityDropdown_project$data = ProjectPriorityDropdown_project;
export type ProjectPriorityDropdown_project$key = {
    readonly " $data"?: ProjectPriorityDropdown_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectPriorityDropdown_project">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPriorityDropdown_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PriorityLevel",
      "kind": "LinkedField",
      "name": "priorityLevel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = '7317d103179cd9270c54e6ecc395151d';
export default node;
